<template>
    <table class="table mt-4">
        <thead>
            <tr>
                <th>Product Name</th>
                <th>Category</th>
                <th>編輯</th>
                <th>狀態</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(product, index) in products" :key="index">
                <td>{{ product.name }}</td>
                <td>{{ product.category.fullname }}</td>
                <td class="d-flex">
                    <product-editor class="mr-2" :product_id="product.id" v-model="products[index]"
                        :categories="categories">Edit
                    </product-editor>
                    <product-deleter :product_id="product.id" @product:deleted="removeProduct(index)">Delete
                    </product-deleter>
                </td>
                <td>
                    <label :for="product.id" style="width: 100%; height: 100%;">
                        <input type="checkbox" :id="product.id" :checked="product.status"
                            v-on:click="switchProductStatus(product.id, product.status)">
                        開啟
                    </label>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
import axios from 'axios';

export default {
    props: {
        categories: {
            default: () => { return [] }
        }
    },
    data() {
        return {
            products: [],
            isLaunched: false
        };
    },
    mounted() {
        this.fetchProducts();
    },
    watch: {
        isLaunched(status) {
            this.switchProductStatus(status);
        }
    },
    methods: {
        fetchProducts() {
            axios.get(base_url + '/admin/api/products')
                .then((...response) => {
                    let data = response[0].data;
                    console.log(response, data);
                    this.products = data;
                })
                .catch((...error) => {
                    console.log(error);
                });
        },
        addProduct(new_product) {
            this.products.unshift(new_product);
        },
        removeProduct(index) {
            this.products.splice(index, 1);
        },
        switchProductStatus(id, status) {
            axios
                .post(base_url + '/admin/api/products/' + id, {
                    status: !status,
                    _method: 'patch'
                })
                .then((response) => {
                    console.log('switch product status');
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
    }
}
</script>
